define('modules/page_generator/views/navigation_tab',['require','exports','module','base/itemview','ldsh!../templates/navigation_tab'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/navigation_tab"),
    tagName: "li",
    className: "ed-single-tab",
    helpers: function() {
      var role = this.model.get("role");
      return {
        translationKey: "editor.toolbar." + role + "TabName",
        isStep: role === "step",
        isPopup: role === "popup"
      };
    }
  });
});

